import { useTranslation } from 'react-i18next'
import { TextFieldController } from 'settle-ui/form/TextFieldController/TextFieldController'
import { logEvent } from 'lib/tracking/segment'
import { useProductFormContext } from '../../../../hooks/useProductForm/useProductForm'
import * as events from '../../../../ProductPage.events'

export const WorkEmailField = () => {
  const { t } = useTranslation()
  const form = useProductFormContext()

  return (
    <TextFieldController
      name="email"
      margin="none"
      fullWidth={true}
      data-testid="email"
      control={form.control}
      label={t('workEmail')}
      onFocus={() => logEvent(events.FOCUS_EMAIL)}
    />
  )
}
